<template>
    <b-tag rounded :type="config.type" class="prd-status-tag">
        <b-icon :icon="config.icon" size="is-small" />
        <span>{{ config.label }}</span>
    </b-tag>
</template>

<script>
export default {
    name: 'PrdStatusTag',
    props: {
        status: { type: Number, required: true },
        tipo: { type: String, default: 'orcamento' },
    },
    computed: {
        config() {
            const grupos = {
                orcamento: {
                    1: ['Em Aberto', 'is-light', 'refresh'],
                    2: ['Enviado', 'is-info', 'send-check-outline'],
                    3: ['Aprovado', 'is-success', 'check-circle-outline'],
                    4: ['Recusado', 'is-danger', 'close-circle-outline'],
                    5: ['Solicitação de alterações', 'prd-status-orange', 'file-edit-outline'],
                    6: ['Cancelado', 'prd-status-black', 'cancel'],
                    7: ['Análise Produção', 'is-warning', 'clipboard-search-outline'],
                    8: ['Análise Produção Finalizada', 'is-info', 'clipboard-check-outline'],
                    9: ['Aprovado Produção', 'is-success', 'factory'],
                },
                itemAnalise: {
                    1: ['Aguardando análise', 'is-light', 'clock-outline'],
                    2: ['Produzimos', 'is-success', 'check-circle-outline'],
                    3: ['Não produzimos', 'is-danger', 'close-circle-outline'],
                    4: ['Pendente', 'is-warning', 'alert-outline'],
                },
                itemFabricacao: {
                    1: ['Aguardando', 'is-light', 'clock-outline'],
                    2: ['Em produção', 'is-info', 'cog-outline'],
                    3: ['Produção parcial', 'is-warning is-light', 'progress-clock'],
                    4: ['Problema', 'is-danger', 'alert-outline'],
                    5: ['Concluído', 'is-success', 'check-circle-outline'],
                },
            }
            const item = (grupos[this.tipo] || grupos.orcamento)[this.status] || ['Desconhecido', 'is-light', 'help-circle-outline']
            return { label: item[0], type: item[1], icon: item[2] }
        },
    },
}
</script>

<style scoped>
.prd-status-tag {
    gap: 0.25rem;
    font-weight: 600;
    white-space: nowrap;
}
.prd-status-tag.prd-status-orange {
    background-color: #f97316;
    color: #fff;
}
.prd-status-tag.prd-status-black {
    background-color: #111;
    color: #fff;
}
.prd-status-tag.prd-status-purple {
    background-color: #7c3aed;
    color: #fff;
}
</style>
